// extracted by mini-css-extract-plugin
export default {"viewport":"AlbumScrollbar_viewport__sHFTZ","scrollbar":"AlbumScrollbar_scrollbar__jbKns","mantine-ScrollArea-thumb":"AlbumScrollbar_mantine-ScrollArea-thumb__61E3s"};